import { render } from "./PrintInstallmentTable8cm.vue?vue&type=template&id=3bbe52fb&scoped=true"
import script from "./PrintInstallmentTable8cm.vue?vue&type=script&lang=js"
export * from "./PrintInstallmentTable8cm.vue?vue&type=script&lang=js"

import "./PrintInstallmentTable8cm.vue?vue&type=style&index=0&id=3bbe52fb&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbe52fb"]])

export default __exports__